import React from "react";

const DeleteIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      {...props}
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 5.5H17.5"
        stroke="#FF6A6A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8334 5.5V17.1667C15.8334 18 15.0001 18.8333 14.1667 18.8333H5.83341C5.00008 18.8333 4.16675 18 4.16675 17.1667V5.5"
        stroke="#FF6A6A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66675 5.50008V3.83341C6.66675 3.00008 7.50008 2.16675 8.33341 2.16675H11.6667C12.5001 2.16675 13.3334 3.00008 13.3334 3.83341V5.50008"
        stroke="#FF6A6A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.33325 9.66675V14.6667"
        stroke="#FF6A6A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6667 9.66675V14.6667"
        stroke="#FF6A6A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DeleteIcon;
